// Theme.js
import { createContext, useContext, useState } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

const lightTheme = {
  background: '#ffffff',
  startColor: '#E6F0FF',
  midColor: '#A8CBFF',
  endColor: '#E6F0FF',
  color: '#333333',
  cardbody: '#F5F6F7',
  cardbg: '#FBFBFB',
  cardStroke: '#E6E6E6',
  formbg: '#FFFFFF',
  inputbg: '#FFFFFF',
  navlink: '#013EBA'
};

const darkTheme = {
  background: '#1D1D1F',
  startColor: '#2A2A2C',
  midColor: '#2A2A2C',
  endColor: '#2A2A2C',
  color: '#FBFBFB',
  cardbody: '#2A2A2C',
  cardbg: '#111111',
  cardStroke: '#353535',
  formbg: '#111111',
  inputbg: '#2A2A2C',
  navlink: '#FFFFFF'
};

const LayoutContext = createContext();

export function useLayoutContext() {
  return useContext(LayoutContext);
}

export const LayoutProvider = ({ children }) => {
  const [theme, setTheme] = useState('dark');

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  const themeMode = theme === 'light' ? lightTheme : darkTheme;

  return (
    <LayoutContext.Provider value={{ theme, toggleTheme }}>
      <StyledThemeProvider theme={themeMode}>{children}</StyledThemeProvider>
    </LayoutContext.Provider>
  );
};
